import request from "@/utils/request";

export default function agentAddChildAgent(data) {
    return request({
        url: `/user/agent/agentAddChildAgent`,
        method: 'post',
        data
    })
}
